import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import type { Video } from '@/types/video';
import { T } from '@tolgee/react';
import { useVideoService } from '@/hooks/useVideoService';

const SingleVideoCard: React.FC<{ video: Video }> = ({ video }) => {
  const [duration, setDuration] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { fetchVideoDuration } = useVideoService();

  useEffect(() => {
    const loadVideoDuration = async () => {
      try {
        const { duration } = await fetchVideoDuration(video.videoUrl || '');
        setDuration(duration);
      } catch (err) {
        setError('Error fetching video duration');
        console.error(err);
      }
    };

    void loadVideoDuration();
  }, [video.imageSrc]);

  return (
    <div className="mt-5 rounded-2xl bg-gray">
      <div className="w-full h-[375px] relative">
        <Image
          src={video.imageSrc as string}
          alt={video.imageAlt as string}
          fill
          className="rounded-2xl object-cover"
        />
        <div className="absolute bottom-5 left-5 p-2.5 flex rounded-2xl flex-col justify-center items-start max-w-xl bg-white/50 backdrop-blur-sm">
          {duration !== null ? (
            <T
              keyName="video_details.video_duration.minute.label"
              params={{ count: Math.round(duration / 60) }}
            />
          ) : (
            <T keyName="loading.label" />
          )}
          {' • '}
          {video.languages}
        </div>
      </div>
      <div className="p-8">
        <h3 className="text-lg h-20 mb-4">{video.title}</h3>
        <p className="text-base opacity-50">{video.author}</p>
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default SingleVideoCard;
